module.exports = __webpack_public_path__ + "img/bg6.d0ffaf91.webp";